import { API_BASE_URL, ensureCsrfToken } from "./apiClient";

export function resolveClientPortalAssetUrl(url) {
  if (!url) {
    return "";
  }
  if (/^https?:\/\//i.test(url)) {
    return url;
  }
  return `${API_BASE_URL}${url.startsWith("/") ? url : `/${url}`}`;
}

export async function uploadClientPortalFile(clientViewId, file, { kind, entityId }) {
  const token = await ensureCsrfToken();
  const params = new URLSearchParams({ kind });
  if (entityId) {
    params.set("entityId", entityId);
  }

  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(
    `${API_BASE_URL}/api/client/views/${clientViewId}/uploads?${params}`,
    {
      method: "POST",
      headers: { "X-CSRF-Token": token },
      body: formData,
      credentials: "include",
    }
  );

  const body = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(body?.message || `Upload failed (${response.status})`);
  }
  return body;
}
